// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"759113a8","215":"2a8716d0","355":"75d06e21","482":"ed3aa3d0","502":"8bec3884","689":"70a72dfc","712":"b3f66e9c","759":"2a0db521","819":"9e0258e5","843":"b1dc572f","885":"cd3d55a1","919":"7bb08bf7","935":"61332842"}[chunkId] + ".chunk.js";
};